import { z } from "zod";

const ChecklistItemSchema = z.object({
  itemId: z.string(),
  listId: z.string(),
  status: z.boolean(),
  title: z.string(),
  notes: z.string(),
  ordinal: z.number(),
});

const ChecklistSchema = z.object({
  listId: z.string(),
  projectId: z.string().nullable(),
  drawId: z.string().nullable(),
  drawItemId: z.string().nullable(),
  name: z.string(),
  scope: z.number(),
  ordinal: z.number(),
  items: z.array(ChecklistItemSchema),
});

export const ChecklistListSchema = z.array(ChecklistSchema);

export type ChecklistItem = z.infer<typeof ChecklistItemSchema>;
export type Checklist = z.infer<typeof ChecklistSchema>;
